import { useCallback } from "react"

import { useStore } from "src/store/lib/useStore"
import { GlobalStore } from "src/store"
import { trackModuleEvent } from "src/analytics/helpers/mixpanel_tracking"
import { MixpanelProperties } from "src/analytics/constants/properties"

export const useTrackNavigation = () => {
    const globalStore = useStore(GlobalStore)

    const trackNavigationClick = useCallback(
        (path: string) => {
            if (path === "/community/posts-and-comments") {
                trackModuleEvent("Open posts and comments", {
                    [MixpanelProperties.EntryPoint]: "Navigation",
                    [MixpanelProperties.Action]: "Click",
                    [MixpanelProperties.UserID]:
                        globalStore.session.user?.adminId,
                })
            }
        },
        [globalStore.session.user?.adminId],
    )

    return { trackNavigationClick }
}
